import algoliasearch from 'algoliasearch';
 
const client = algoliasearch("IWF0LVF4B0", "38ebaa71f8fa88dac767a63ee175ed93");
const index = client.initIndex("users");

export default index;